import {
  CLEAR,
  ADD,
} from './mutation-types';

export default {
  [CLEAR](state) {
    state.path = undefined;
  },
  [ADD](state, path) {
    state.path = path;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/redirect/mutations.js